<template>
  <div class="set_main">
    <div class="account-tit">
      <h1 class="title">
        {{ $t('message["1401"]') }}
      </h1>
    </div>
    <a-form
      :form="form"
      :hide-required-mark="true"
      class="inquiry-detail"
      @submit="handleSubmit"
    >
      <a-form-item
        class="code_form_item"
        :label="curEmailTit"
      >
        <a-input
          v-decorator="[
            'email',
            { rules: decorators.oldemail,initialValue: nativeEmail }]"
          :disabled="true"
        />
      </a-form-item>
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.checkcode"
          :placeholder="curEmailPlace"
        />
        <get-code
          class="find-pwd-link ml-16"
          :email="nativeEmail"
          type="2"
          :is-disabled="false"
          @getRes="sendCurrentEmailCode"
        />
      </a-form-item>
      <a-form-item
        class="code_form_item"
        :label="newEmailTit"
      >
        <a-input
          v-decorator="decorators.newemail"
          :placeholder="newEmailPlace"
        />
      </a-form-item>
      <a-form-item
        :label="validTit"
        class="password-box"
      >
        <a-input
          v-decorator="decorators.newcheckcode"
          :placeholder="newEmailValidPlace"
        />
        <get-code
          class="find-pwd-link ml-16"
          :newemail="form.getFieldValue('newemail')"
          type="6"
          :is-disabled="false"
          @getRes="sendNewEmailCode"
        />
      </a-form-item>
      <a-form-item>
        <div class="form_btn">
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["1161"]') }}
          </a-button>
          <a-button
            type="default"
            @click="resetForm"
          >
            {{ $t('message["896"]') }}
          </a-button>
        </div>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import getCode from '@/components/pc/GetCode'
import { mapState, mapActions } from 'vuex'
export default {
  components: { getCode },
  data () {
    return {
      nativeEmail: ''
    }
  },
  computed: {
    ...mapState('account/modify', ['decorators', 'accountDetail']),
    curEmailTit () {
      return this.$t('message["178"]')
    },
    curEmailPlace () {
      return this.$t('message["761"]')
    },
    newEmailPlace () {
      return this.$t('message["819"]')
    },
    newEmailValidPlace () {
      return this.$t('message["820"]')
    },
    newEmailTit () {
      return this.$t('message["1345"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
    this.setKey()
    const chain = await this.fetchAccountInfoDatas()
    chain.onSuccess(res => {
      this.setKey()
    })
      .fetch()
  },
  methods: {
    ...mapActions('account/modify', ['fetchAccountInfoDatas', 'modifyEmail']),
    setKey (vm) {
      if (this.accountDetail && this.accountDetail.email) {
        // this.$set(this.mainForm, 'email', this.accountDetail.email)
        this.form.setFieldsValue({ 'email': this.accountDetail.email })
        this.nativeEmail = this.accountDetail.email
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          // console.log('表单值：', values)
          const chain = await this.modifyEmail()
          chain.params(values)
            .onSuccess(res => {
              this.$router.push({ name: 'AccountInfo' })
            })
            .onFail(err => {
              console.log(err)
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    // 跳转到个人信息
    resetForm () {
      this.$router.push({ name: 'AccountInfo' })
    },
    sendNewEmailCode (res) {
      console.log(res)
    },
    // 获取手机验证码
    sendCurrentEmailCode (res) {
      console.log(res)
    },
    toPhone () {
      this.$router.push('/modify/phone')
    }
  }
}
</script>

<style scoped lang="scss">
.set_main {
 padding: 24px 40px;
 .account-tit {
   margin-bottom: 24px;
 }
  .form_btn {
  button {
    margin-right: 16px
  }
}
}
</style>
